<template>
    <div class="mt-3" v-if="loaded">
        <b-row>
            <b-col cols=12 lg=6 class="mt-2 mb-2">
                <b-row class="mb-3">
                    <b-col class="text-center"><b>Anmeldungen:</b></b-col>
                </b-row>

                <b-row>
                    <b-col></b-col>
                    <b-col class="text-center">Online:</b-col>
                    <b-col class="text-center">Papier:</b-col>
                    <b-col class="text-center">Gesamt:</b-col>
                </b-row>

                <b-row v-for="(age) in [3, 5, 7]" :key="'registrations_' + age">
                    <b-col class="sm-1 text-right"><b>{{ age + '/' + (parseInt(age) + 1) }}:</b></b-col>
                    <b-col class="text-center">{{ registrations[age].online }}</b-col>
                    <b-col class="text-center">{{ registrations[age].paper }}</b-col>
                    <b-col class="text-center">{{ registrations[age].total }}</b-col>
                </b-row>

                <b-row>
                    <b-col class="sm-1 text-right"><b>Gesamt:</b></b-col>
                    <b-col class="text-center">{{ registrations.total.online }}</b-col>
                    <b-col class="text-center">{{ registrations.total.paper }}</b-col>
                    <b-col class="text-center">{{ registrations.total.total }}</b-col>
                </b-row>
            </b-col>

            <b-col cols=12 lg=6 class="mt-2 mb-2">
                <b-row class="mb-3">
                    <b-col class="text-center"><b>Ergebnisse:</b></b-col>
                </b-row>

                <b-row>
                    <b-col></b-col>
                    <b-col class="text-center">Online:</b-col>
                    <b-col class="text-center">Papier:</b-col>
                    <b-col class="text-center">Gesamt:</b-col>
                </b-row>

                <b-row v-for="(age) in [3, 5, 7]" :key="'results_' + age">
                    <b-col class="sm-1 text-right"><b>{{ age + '/' + (parseInt(age) + 1) }}:</b></b-col>
                    <b-col class="text-center">{{ results[age].online }}</b-col>
                    <b-col class="text-center">{{ results[age].paper }}</b-col>
                    <b-col class="text-center">{{ results[age].total }}</b-col>
                </b-row>


                <b-row>
                    <b-col class="sm-1 text-right"><b>Gesamt:</b></b-col>
                    <b-col class="text-center">{{ results.total.online }}</b-col>
                    <b-col class="text-center">{{ results.total.paper }}</b-col>
                    <b-col class="text-center">{{ results.total.total }}</b-col>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>
<script>
  export default {
    name: 'CompetitionStatsTable',
    props: ['competition'],

    data: function () {
      return {
        registrations: {},
        results: {},
        total: {},
        stats: {},
        loaded: false
      }
    },

    watch: {
      'competition': function () {
        this.load()
      }
    },

    mounted () {
      this.load()
    },

    methods: {
      load: function () {
        if (!this.competition) {
          return
        }

        this.axios.get('/competitions/' + this.competition.id + '/stats')
          .then((rsp) => {
            for (let key in rsp.data) {
              this.$set(this, key, {
                total: {}
              })
              let data = rsp.data[key]

              let online = 0
              let paper = 0
              let total = 0

              for (let age = 3; age <= 7; age = age + 2) {
                this[key][age] = {
                  online: 0,
                  paper: 0,
                  total: 0
                }

                this[key][age] = {
                  online: 0,
                  paper: 0,
                  total: 0
                }

                Object.keys(this.registrations[age]).forEach((t) => {
                  this[key][age][t] = data[age][t] + data[age + 1][t]
                })

                online += this[key][age].online
                paper += this[key][age].paper
                total += this[key][age].total
              }

              this[key].total.online = online
              this[key].total.paper = paper
              this[key].total.total = total
            }

            this.loaded = true
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/competitions/admin/stats/Table.vue